import { useCallback, useRef, useState } from "react";
import { faStar as filledStar } from "@fortawesome/pro-solid-svg-icons";
import { faStar as emptyStar } from "@fortawesome/pro-light-svg-icons";
import cx from "classnames";

import { rangeArray } from "common/utils/numbers";
import { useIntersectionObserver } from "common/utils/dom";
import Icon from "common/components/Icon";

import styles from "../styles/ReviewStars.module.less";

const ReviewStars = ({ rating }: { rating: number }) => {
  const ref = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(true);
  const setIsVisibleEnabled = useCallback(() => setIsVisible(true), []);

  useIntersectionObserver(ref, setIsVisibleEnabled, { threshold: 1 });

  return (
    <div className={cx(styles.container, isVisible && styles.visible)}>
      <div className={cx(styles.stars, styles.empty)} style={{ width: rating / 5 }}>
        {rangeArray(1, 6).map((starNum) => (
          <Icon key={starNum} icon={emptyStar} className={styles.star} />
        ))}
      </div>
      <div className={cx(styles.stars, styles.filled)} style={{ width: `${(rating / 5) * 100}%` }}>
        {rangeArray(1, 6).map((starNum) => (
          <Icon key={starNum} icon={filledStar} className={styles.star} />
        ))}
      </div>
    </div>
  );
};

export default ReviewStars;
